import { render, staticRenderFns } from "./FormLabelDescripcion.vue?vue&type=template&id=3bf40c13"
import script from "./FormLabelDescripcion.vue?vue&type=script&lang=js"
export * from "./FormLabelDescripcion.vue?vue&type=script&lang=js"
import style0 from "./FormLabelDescripcion.vue?vue&type=style&index=0&id=3bf40c13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports